import { getEnvironmentVariable } from "src/utils/environment";

const webLinks = {
  login: getEnvironmentVariable("WEB_LOGIN"),
  pricing: getEnvironmentVariable("WEB_PRICING"),
  dashboardWebapp: getEnvironmentVariable("WEB_DASHBOARD_WEBAPP"),
  explore: getEnvironmentVariable("WEB_EXPLORE"),
  index: getEnvironmentVariable("WEB_URL")
};

export { webLinks };
